import React, { PropTypes } from 'react';
import alert from 'alertify.js';
import { SubmissionError } from 'redux-form';
import axios from './../../../constants/axios';
import NewSaleReturnForm from './NewSaleReturnForm';

class NewSaleReturn extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoiceInfo: {}
      };
   }

   handleBlurInvoiceId = (e) => {
      this.setState({
         invoiceInfo: {},
      });
      if (e.target.value) {
         // make an ajax requrest
         axios.get('/saleReturns/getSaleReturnInvoiceInfoById/' + e.target.value)
            .then((res) => {
               this.setState({
                  invoiceInfo: res.data,
               });
            })
            .catch((err) => {
               alert.error(err.response.data);
            });
      }
   };

   submit = (inputs) => {
      const { invoiceInfo } = this.state;
      return axios.post(`saleReturns/postSaleReturnInvoiceInfoById/${invoiceInfo.id}`, inputs)
         .then((res) => {
            if (res.status === 201) {
               alert.success('invoice created.');
               this.context.router.push('/saleReturn');
            } else {
               alert.error('Something went unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };


   render() {
      const { invoiceInfo } = this.state;
      return (
         <div className="NewSaleReturn" >
            <h1>New Sales Return</h1>
            <div>
               <div>
                  <label htmlFor="invoiceId" >
                     <input type="text" ref="invoiceId" onBlur={(e) => this.handleBlurInvoiceId(e)} />
                  </label>
               </div>
               <div>
                  <h4>Invoice Information</h4>
                  <p>id:{invoiceInfo.id}</p>
                  <p>contact: {invoiceInfo.name}</p>
                  <p>mobile: {invoiceInfo.mobile}</p>
               </div>
            </div>
            {invoiceInfo.id &&
            <NewSaleReturnForm submit={this.submit} items={invoiceInfo.items} />
            }
         </div>
      );
   }
}

NewSaleReturn.propTypes = {};
NewSaleReturn.contextTypes = {
   router: PropTypes.object
};

export default NewSaleReturn;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/SaleReturn/NewSaleReturn.js
 **/